import { authentication, createDirectus, rest } from "@directus/sdk";
import { DIRECTUS_URL } from "../config";

// Cookie mode keeps the Directus refresh token in an httpOnly cookie and the
// short-lived access token in memory only, so this app never stores a token in
// browser storage and no credentials are built into the bundle. The in-memory
// access token is what proves the signed-in teacher to the learner gateway
// when a learner tablet is set up.
const directus = createDirectus(DIRECTUS_URL)
  .with(authentication("cookie", { credentials: "include", autoRefresh: true }))
  .with(rest({ credentials: "include" }));

export default directus;
